export const environment = {
	production: false,
	apiUrl: 'https://workflow-back-qas-f6vbbcweka-uc.a.run.app/api/',
	googleClientID: '83588238973-6pm192v6buimg8db30flk881ls6ep9sn.apps.googleusercontent.com'
};
